(function () {
  var el = document.getElementById('IntroLoader');
  if (!el) return;

  if (document.documentElement.classList.contains('intro-loader-skipped')) {
    var skippedEl = document.getElementById('IntroLoader');
    if (skippedEl && skippedEl.parentNode) {
      skippedEl.parentNode.removeChild(skippedEl);
    }
    return;
  }

  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  var path = el.querySelector('.intro-loader__slash-line');
  var line1 = el.querySelector('.intro-loader__line--sub');
  var line2 = el.querySelector('.intro-loader__line--main');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var fixedIntroMs = parseInt(el.getAttribute('data-fixed-intro-ms') || '10000', 10);
  var zoomHoldMs = parseInt(el.getAttribute('data-zoom-hold-ms') || '500', 10);
  var linePauseAt30Ms = parseInt(el.getAttribute('data-line-pause-at-30-ms') || '500', 10);
  var line1ZoomInMs = parseInt(el.getAttribute('data-line1-zoom-in-ms') || '1600', 10);
  var line1ZoomOutMs = parseInt(el.getAttribute('data-line1-zoom-out-ms') || '1300', 10);
  var line2ZoomInMs = 800;
  var line2SettleMs = 450;
  var endHoldMs = 1000;
  var finalFadeDelayMs = 300;
  var finalFadeDurationMs = 500;

  var finished = false;
  var tl = null;
  var motion = null;
  var gsap = null;

  var durationMs = fixedIntroMs;
  var loaderTo30Ms;
  var loaderRestMs;
  var tLine1Start;
  var tPeakStart;
  var tPeakEnd;
  var tLine2Start;
  var tLine2PeakEnd;
  var minTotalMs;
  var loaderCompleteMs;
  var tailStartMs;
  var tailStartSec;
  var pAfterLine1ZoomIn;

  function computeTimelineTimes(totalMs) {
    durationMs = totalMs;
    loaderTo30Ms = Math.max(900, durationMs * 0.3);
    loaderRestMs = Math.max(1200, durationMs - loaderTo30Ms - linePauseAt30Ms);

    tLine1Start = loaderTo30Ms;
    tPeakStart = tLine1Start + line1ZoomInMs;
    tPeakEnd = tPeakStart + zoomHoldMs;

    pAfterLine1ZoomIn = 0.52;

    tLine2Start = tPeakEnd;
    tLine2PeakEnd = tLine2Start + line2ZoomInMs + line2SettleMs;
    loaderCompleteMs = tLine2Start + line2ZoomInMs;
    tailStartMs = Math.max(
      loaderCompleteMs + finalFadeDelayMs,
      durationMs - finalFadeDurationMs
    );
    minTotalMs = Math.max(tailStartMs + finalFadeDurationMs, tLine2PeakEnd + endHoldMs);
    tailStartSec = tailStartMs / 1000;
  }

  computeTimelineTimes(durationMs);
  if (minTotalMs > durationMs) {
    computeTimelineTimes(minTotalMs);
  }

  function readMotionFromCss() {
    var css = window.getComputedStyle(el);
    function cssNum(varName, fallback) {
      var raw = parseFloat(css.getPropertyValue(varName));
      return Number.isFinite(raw) ? raw : fallback;
    }

    var line1BaseFont = cssNum('--intro-line1-base-font', 24);
    var line1PeakFont = cssNum('--intro-line1-peak-font', 72);
    var settleScale = line1PeakFont > 0 ? line1BaseFont / line1PeakFont : 1 / 3;

    return {
      line1StartScale: 0.6 * settleScale,
      line1PeakScale: 1,
      line1SettleScale: settleScale,
      line1ExitScale: 1.08 * settleScale,
      line1StartY: cssNum('--intro-line1-start-y', 24),
      line1ExitY: cssNum('--intro-line1-exit-y', -74),
      line2StartY: cssNum('--intro-line2-start-y', 24),
      line2ExitY: cssNum('--intro-line2-exit-y', -72),
      line2ExitScale: cssNum('--intro-line2-exit-scale', 0.52)
    };
  }

  motion = readMotionFromCss();

  function finish() {
    if (finished) return;
    finished = true;
    if (tl) {
      tl.kill();
      tl = null;
    }
    document.removeEventListener('keydown', onKey);
    if (gsap && path && line1 && line2) {
      gsap.set(path, { strokeDashoffset: 0 });
      gsap.set([line1, line2], { opacity: 0, y: -14, scale: 0.8 });
    }
    el.classList.add('intro-loader--exit');
    document.body.classList.remove('intro-loader-active');
    try {
      if (!(window.Shopify && window.Shopify.designMode)) {
        sessionStorage.setItem('contrabandIntroSeen', '1');
      }
    } catch (e) {
      /* ignore */
    }
    window.setTimeout(function () {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }, 950);
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      finish();
    }
  }

  function runReducedMotion() {
    el.classList.add('intro-loader--reduced');
    document.body.classList.add('intro-loader-active');
    document.addEventListener('keydown', onKey);
    window.setTimeout(finish, 400);
  }

  function runFallback() {
    document.body.classList.add('intro-loader-active');
    document.addEventListener('keydown', onKey);
    window.setTimeout(finish, 400);
  }

  function loadGsap() {
    if (window.gsap) {
      return Promise.resolve(window.gsap);
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
      script.async = true;
      script.onload = function () {
        if (window.gsap) {
          resolve(window.gsap);
        } else {
          reject(new Error('GSAP unavailable'));
        }
      };
      script.onerror = function () {
        reject(new Error('GSAP failed to load'));
      };
      document.head.appendChild(script);
    });
  }

  function runAnimation(loadedGsap) {
    gsap = loadedGsap;

    if (!path || !line1 || !line2) {
      runFallback();
      return;
    }

    document.body.classList.add('intro-loader-active');
    document.addEventListener('keydown', onKey);

    gsap.set(path, { strokeDashoffset: 1 });
    gsap.set(line1, {
      opacity: 0,
      y: motion.line1StartY,
      scale: motion.line1StartScale
    });
    gsap.set(line2, { opacity: 0, y: motion.line2StartY, scale: 0.6 });

    tl = gsap.timeline({
      onComplete: finish
    });

    var loaderState = { p: 0 };
    tl.to(
      loaderState,
      {
        p: 0.3,
        duration: loaderTo30Ms / 1000,
        ease: 'power1.out',
        onUpdate: function () {
          path.style.strokeDashoffset = String(1 - loaderState.p);
        }
      },
      0
    );

    tl.to(
      loaderState,
      {
        p: pAfterLine1ZoomIn,
        duration: line1ZoomInMs / 1000,
        ease: 'power2.out',
        onUpdate: function () {
          path.style.strokeDashoffset = String(1 - loaderState.p);
        }
      },
      tLine1Start / 1000
    );

    tl.to(loaderState, { p: pAfterLine1ZoomIn, duration: zoomHoldMs / 1000, ease: 'none' }, tPeakStart / 1000);

    var loaderFinalRunMs = Math.max(0, loaderCompleteMs - tLine2Start);
    tl.to(
      loaderState,
      {
        p: 1,
        duration: loaderFinalRunMs / 1000,
        ease: 'power1.inOut',
        onUpdate: function () {
          path.style.strokeDashoffset = String(1 - loaderState.p);
        }
      },
      tLine2Start / 1000
    );
    tl.to(loaderState, { p: 1, duration: finalFadeDelayMs / 1000, ease: 'none' }, loaderCompleteMs / 1000);

    tl.to(
      line1,
      {
        opacity: 1,
        y: 0,
        scale: motion.line1PeakScale,
        duration: line1ZoomInMs / 1000,
        ease: 'power2.out'
      },
      tLine1Start / 1000
    );
    tl.to(
      line1,
      {
        scale: motion.line1SettleScale,
        duration: line1ZoomOutMs / 1000,
        ease: 'power2.out'
      },
      tPeakEnd / 1000
    );

    tl.to(
      line2,
      { opacity: 1, y: 0, scale: 1, duration: line2ZoomInMs / 1000, ease: 'power3.out' },
      tLine2Start / 1000
    );
    tl.to(
      line2,
      { scale: 1, duration: line2SettleMs / 1000, ease: 'power2.out' },
      (tLine2Start + line2ZoomInMs) / 1000
    );

    tl.to(
      line1,
      {
        opacity: 0,
        y: motion.line1ExitY,
        scale: motion.line1ExitScale,
        duration: finalFadeDurationMs / 1000,
        ease: 'sine.inOut'
      },
      tailStartSec
    );
    tl.to(
      line2,
      {
        opacity: 0,
        y: motion.line2ExitY,
        scale: motion.line2ExitScale,
        duration: finalFadeDurationMs / 1000,
        ease: 'sine.inOut'
      },
      tailStartSec
    );
  }

  function runMobileFast() {
    var mobileDurationMs = parseInt(el.getAttribute('data-mobile-intro-ms') || '1500', 10);
    el.classList.add('intro-loader--mobile-fast');
    document.body.classList.add('intro-loader-active');
    document.addEventListener('keydown', onKey);
    window.setTimeout(finish, mobileDurationMs);
  }

  if (reduced) {
    runReducedMotion();
    return;
  }

  if (isMobile) {
    runMobileFast();
    return;
  }

  loadGsap().then(runAnimation).catch(runFallback);
})();
